// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"g1Wrg":[function(require,module,exports) {
require("84f5b438ebc411b").register(require("400d106abb0042f2").getBundleURL("kEMsi"), JSON.parse('["kEMsi","index.7e9a15dd.js","bPuwu","error.4939cce4.svg","hbmNi","not-found.4dd1af4a.svg","fvJJ0","BatonTurboWeb-Medium.8f9369de.eot","hDLIR","BatonTurboWeb-Medium.dc3d13f3.woff","1jHFF","BatonTurboWeb-Regular.8391f47d.eot","h5UmW","BatonTurboWeb-Regular.0c6896ff.woff","7dCiS","access-denied.9fd2fa7a.svg","hKcs6","chevron-left.cbd10248.svg","es7lC","plus.63a4d2ad.svg","1xwDG","globe.b41623af.svg","8ifm1","phone.6017082e.svg","8EeOE","email.5d6e8d67.svg","iLrf3","chevron-down.380d6a72.svg","kKYF5","archivebox.c92926c8.svg","9HmTN","pencil-24-circle.011a35d6.svg","i6VvW","company.89454a7a.svg","5s02X","info-blue.1726a725.svg","4PmQI","person.c8f4d5f2.svg","5pENp","screening_active.69a9527c.svg","cUvga","screening_inactive.b319bf68.svg","hyXdX","arrow-circular.f7fed9d0.svg","4DGx7","checkmark-green.184c5d03.svg","c7FPf","triangle-filled-exclamation.3e9912d3.svg","coKxV","timeout.661b8f7c.svg","6fHAt","chevron-right.a0a23595.svg","hp0QN","pencil.8571f611.svg","6uuXt","status-approve-review.f93a1cb6.svg","lgbg1","status-follow-up.fcc2b3ce.svg","1Jkr3","status-open-matches.d594b4fc.svg","aMpLD","status-open-measures.55e20f4d.svg","dk96Q","status-ownership-updates.0e3b0305.svg","5HSSq","status-ready.802e83cf.svg","cM9X7","status-started.f854b6aa.svg","gYiw6","status-waiting.431f74da.svg","hjn48","subtract-red.17c73de5.svg","9wrto","dashed-border.505f1231.svg","82GUK","arrow-down-rectangle.921533ac.svg","jaPM9","folders.86995256.svg","9wqnL","restore.98d9fc7c.svg","aiAML","star-filled.9bf97db3.svg","b0xwP","trash.1cf834a7.svg","9j4Zu","folder.c9149cec.svg","kQvoe","project.fc43e938.svg","60KXL","external-link-white-icon.3cdd0fca.svg","e527o","plus-major.5e3027f4.svg","52UrA","tag.39dcae41.svg","455GI","plus-major-white.156b00bc.svg","jjOWZ","lock.a8408123.svg","5rrOA","checkmark-white.384db1ed.svg","lrMco","copy.8beccb98.svg","1rh8k","link.56b9e736.svg","cJJU4","remind.148dc4b8.svg","jn1xQ","email-small.c9ba2284.svg","agNX3","envelope.52490e19.svg","cIkJW","hourglass.140e41eb.svg","hmqMp","checkmark.20a24c77.svg","banIX","info-circle.a67547b4.svg","1oPws","file.e4449673.svg","faTlo","pen-line.3076bad4.svg","k01BK","calendar.58f765c4.svg","ae6Qe","exclamationmark-triangle-filled-red.dd403069.svg","2NvlP","inactive-icon.8d0a78ba.svg","57m3d","status-approved.d3e12338.svg","bbOEq","text-bubble.7df85c8b.svg","j7QcI","checkmark-circle-filled-success-dark.27e24aa3.svg","hQAy0","triangle-filled-exclamation-monochrome.0548a6ba.svg","bB9Y6","arrow-down.b3ca9e20.svg","8258l","arrow-up.1c3097c7.svg","iIeHE","circle-cross.17c73de5.svg","aEvVM","status-rejected.fe7f7c23.svg","1SSTu","doc-text.0848006a.svg","9hI70","identity.98bce255.svg","chuhg","gear-white.493e823c.svg","fbYTX","xmark-circle.96dbe7f9.svg","iZqI0","Checklist.ba951e88.svg","25taz","question-mark.b974b79a.svg","jxyJL","folder-plus.0b47208f.svg","aF9K8","gear.274a89d3.svg","3AaVK","person-arrow-toward.a29522c3.svg","4EKzv","no-match.7f802bb1.svg","6MZdb","star.91ede1ca.svg","cGXEh","fresh-customer.0240b6c7.svg","2K7rL","link-chevron-right.d7eeb1fa.svg","iny12","logout.cccce5c4.svg","P4wWh","match.9559794d.svg","8qqup","red-flag.b2c2fa9e.svg","kDpnl","match_status_confirmed.d566b1b6.svg","9jzlc","match_status_new.8d0fa3b2.svg","bwSrV","match_status_rejected.cc1f5501.svg","dIft4","clock.5aa78d4a.svg","bD8g1","plan-update-projects.3aeb1de4.png","8lPOI","lines-horizontal-3.95c876a6.svg","6z4U8","xmark.a26e6962.svg","6ebTa","list-ol.da0bd3bd.svg","boGoQ","list-ul.32d174ca.svg","fYqGs","eye.9931954b.svg","9FzR1","remove.670aafb5.svg","fD95X","arrow-right-offset-circle.59da6ee8.svg","gYE3I","kdk-logo.96cc0459.svg","03z2E","import-company.89454a7a.svg","kklEg","dashboard.e7e739c3.svg","brV81","mimic.8f1b187c.js","eaKWO","index.fd9ee65c.css"]'));

},{"84f5b438ebc411b":"9zCcB","400d106abb0042f2":"75UoR"}],"9zCcB":[function(require,module,exports) {
"use strict";
var mapping = new Map();
function register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function resolve(id) {
    var resolved = mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
module.exports.register = register;
module.exports.resolve = resolve;

},{}],"75UoR":[function(require,module,exports) {
"use strict";
var bundleURL = {};
function getBundleURLCached(id) {
    var value = bundleURL[id];
    if (!value) {
        value = getBundleURL();
        bundleURL[id] = value;
    }
    return value;
}
function getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return getBaseURL(matches[2]);
    }
    return "/";
}
function getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
exports.getBundleURL = getBundleURLCached;
exports.getBaseURL = getBaseURL;
exports.getOrigin = getOrigin;

},{}]},["g1Wrg"], null, "parcelRequirebad5")

//# sourceMappingURL=index.runtime.142352a5.js.map
